
import Vue from 'vue'
import axios from 'axios'
import { mapFields } from 'vuex-map-fields'
import HelperTooltip from '@/components/HelperTooltip.vue'

export default Vue.extend({
  components: {
    HelperTooltip
  },

  data: () => ({
    fetching: false
  }),

  computed: {
    ...mapFields({
      pushButton: 'termostatFilterCriteria.pushButton',
      touchButton: 'termostatFilterCriteria.touchButton',
      black: 'termostatFilterCriteria.black',
      white: 'termostatFilterCriteria.white',
      bigScreen: 'termostatFilterCriteria.bigScreen',
      embeddedInSwitch: 'termostatFilterCriteria.embeddedInSwitch',
      withWiFi: 'termostatFilterCriteria.withWiFi',
      withWires: 'termostatFilterCriteria.withWires',
      wireless: 'termostatFilterCriteria.wireless',
      cooling: 'termostatFilterCriteria.cooling',
      heating: 'termostatFilterCriteria.heating'
    })
  },

  methods: {
    getTermostatProducts () {
      this.fetching = true
      this.$emit('submitFilter')

      axios.post(process.env.VUE_APP_BACKEND_URL + '/backend/?termostat',
        JSON.stringify(this.$store.getters.getTermostatFilterCriteriaAsObj),
        {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          this.$store.commit('setTermostatProductLists', response.data)
        })
        .catch(error => console.log(error))
        .finally(() => { this.fetching = false })
    }
  }
})
